import { getCookie } from "typescript-cookie";
import { jwtDecode } from "jwt-decode";
import { EUserType } from "../../constants/Constants";
var oktaTokenCookieName = "okta-token-storage_accessToken";
export var getOktaToken = function () {
    var _a;
    var oktaToken = getCookie(oktaTokenCookieName);
    if (oktaToken) {
        try {
            var tokenJson = JSON.parse(oktaToken);
            return (_a = tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.accessToken) !== null && _a !== void 0 ? _a : "";
        }
        catch (error) {
            console.error("Error parsing Okta token", error);
        }
    }
    return "";
};
export var getOktaUserEmail = function () {
    var oktaToken = getCookie(oktaTokenCookieName);
    if (oktaToken) {
        try {
            var tokenJson = JSON.parse(oktaToken);
            var oktaUserDetail = jwtDecode(tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.accessToken);
            var email = oktaUserDetail === null || oktaUserDetail === void 0 ? void 0 : oktaUserDetail.sub;
            return email || "";
        }
        catch (error) {
            console.error("Error parsing Okta token", error);
            return "";
        }
    }
    return "";
};
export var getOktaUserUid = function () {
    var _a;
    var oktaToken = getCookie(oktaTokenCookieName);
    if (oktaToken) {
        try {
            var tokenJson = JSON.parse(oktaToken);
            //const oktaUserDetail: any = jwtDecode(tokenJson);
            var uid = (_a = tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.claims) === null || _a === void 0 ? void 0 : _a.uid;
            return uid;
        }
        catch (error) {
            console.error("Error parsing UID", error);
            return "";
        }
    }
    return "";
};
export var isInternaluser = function () {
    var oktaToken = getCookie(oktaTokenCookieName);
    if (oktaToken) {
        try {
            var tokenJson = JSON.parse(oktaToken);
            var oktaUserDetail = jwtDecode(tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.accessToken);
            var userType = oktaUserDetail.usertype;
            if (userType === EUserType.INTERNAL) {
                return true;
            }
            return false;
        }
        catch (error) {
            console.error("Error parsing Okta token", error);
            return false;
        }
    }
    return false;
};
